import * as React from 'react';
import { useSelector } from 'react-redux';

import { Layout } from '../../components/Layout';
import { PageLayout } from '../../components/PageLayout';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { MainInfoContainer } from '../MainInfo';
import { NoReviewsContainer } from '../NoReviews';
import { ReviewsContainer } from '../Reviews';
import { MasterReviewContainer } from '../MasterReviewContainer';
import { useFormsOpener } from './hooks/useFormsOpener';

export function PageContainer() {
  const { reviewsCount, questionsCount } = useSelector(getNewbuildingInfo);

  useFormsOpener();

  if (!reviewsCount && !questionsCount) {
    return <NoReviewsContainer />;
  }

  return (
    <Layout>
      <PageLayout>
        <MainInfoContainer />
        <MasterReviewContainer />
        <ReviewsContainer />
      </PageLayout>
    </Layout>
  );
}
